import axios from "axios";

export const readGoalsInMatchByTeam = async ({ matchId, teamId }: any) => {
  try {
    let formData = new FormData();

    formData.append("matchId", matchId);
    formData.append("teamId", teamId);
    formData.append("token", "token");

    const { data } = await axios({
      method: "post",
      url: `${process.env.REACT_APP_API_HOST}/api/goal/read_goal_in_match_by_team.php`,
      data: formData,
      headers: {
        Accept: "application/json",
      },
    });

    return data;
  } catch (error: any) {
    if (error.response) {
      return error.response.data; // => the response payload
    } else {
      //console.log(error);
    }
  }
};
